import ClearIcon from "@mui/icons-material/Clear";
import { Box, IconButton, InputAdornment, TextField } from "@mui/material";
import React, { useState } from "react";
import gregorian from "react-date-object/calendars/gregorian";
import persian from "react-date-object/calendars/persian";
import gregorian_en from "react-date-object/locales/gregorian_en";
import persian_fa from "react-date-object/locales/persian_fa";
import DatePicker, { DateObject } from "react-multi-date-picker";

const DateInputComponent = ({
  x,
  formData,
  setFormData,
  isGregorian = false,
}) => {
  const [selectedDate, setSelectedDate] = useState(null);

  // بررسی آیا پاسخ برای این سوال وجود دارد
  const existingAnswer = formData.find((item) => item.questionId === x.id);

  // مقدار اولیه را از formData می‌گیریم
  React.useEffect(() => {
    if (existingAnswer?.answer) {
      // تبدیل رشته تاریخ به شیء Date مناسب
      const dateParts = existingAnswer.answer.split("-");
      if (dateParts.length === 3) {
        if (isGregorian) {
          // برای تاریخ میلادی
          const date = new Date(dateParts[0], dateParts[1] - 1, dateParts[2]);
          setSelectedDate(date);
        } else {
          // برای تاریخ شمسی - استفاده از کتابخانه react-date-object
          const dateObject = new DateObject({
            year: parseInt(dateParts[0]),
            month: parseInt(dateParts[1]),
            day: parseInt(dateParts[2]),
            calendar: persian,
          });
          setSelectedDate(dateObject);
        }
      }
    }
  }, [existingAnswer, isGregorian]);

  // تابع برای تغییر تاریخ
  const handleDateChange = (dateObject) => {
    if (dateObject) {
      setSelectedDate(dateObject);

      // فرمت تاریخ به صورت YYYY-MM-DD برای ارسال به سرور
      const year = dateObject.year;
      const month = String(dateObject.month).padStart(2, "0");
      const day = String(dateObject.day).padStart(2, "0");
      const formattedDate = `${year}-${month}-${day}`;

      // به روز رسانی formData
      setFormData((prevData) => {
        const existingIndex = prevData.findIndex(
          (item) => item.questionId === x.id,
        );

        if (existingIndex > -1) {
          const newData = [...prevData];
          newData[existingIndex] = {
            ...newData[existingIndex],
            answer: formattedDate,
          };
          return newData;
        }

        return [
          ...prevData,
          {
            questionId: x.id,
            answer: formattedDate,
          },
        ];
      });
    } else {
      // حذف تاریخ
      setSelectedDate(null);
      setFormData((prevData) =>
        prevData.filter((item) => item.questionId !== x.id),
      );
    }
  };

  // تابع برای پاک کردن تاریخ انتخاب شده
  const handleClearDate = (e) => {
    e.stopPropagation(); // جلوگیری از باز شدن datepicker
    setSelectedDate(null);
    setFormData((prevData) =>
      prevData.filter((item) => item.questionId !== x.id),
    );
  };

  return (
    <Box pb="20px">
      <DatePicker
        value={selectedDate}
        onChange={handleDateChange}
        calendar={isGregorian ? gregorian : persian}
        locale={isGregorian ? gregorian_en : persian_fa}
        calendarPosition="bottom-right"
        render={(value, openCalendar) => (
          <TextField
            label={x.question}
            value={value ? value.toString() : ""}
            onClick={openCalendar}
            fullWidth
            InputProps={{
              readOnly: true,
              endAdornment: (
                <InputAdornment position="end">
                  {selectedDate && (
                    <IconButton
                      onClick={handleClearDate}
                      edge="end"
                      size="small"
                      sx={{ mr: 1 }}
                    >
                      <ClearIcon />
                    </IconButton>
                  )}
                  {/* <IconButton onClick={openCalendar} edge="end" size="small">
                    <EventIcon />
                  </IconButton> */}
                </InputAdornment>
              ),
            }}
          />
        )}
      />
    </Box>
  );
};

export default DateInputComponent;
